// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"95de86bc","453":"9275a9af","796":"ed63d643"}[chunkId] + ".chunk.js";
};